class Loadmore extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  init(){
    const _this = this;
    this.button = this.querySelector("button");
    if (!this.button) return;
    this.button.addEventListener("click", function() {
      _this.scanData();
    });
  }
  scanData() {
    const _this = this;
    const currentUrl = window.location.href;
    const param = window.location.search;
    let url = this.dataset.url;
    if (!url) return;
    if (param.length > 0) {
      url = currentUrl+url.replaceAll("?", "&");
    }
    this.classList.add("loading");
    fetch(url)
      .then(response => response.text())
      .then(text => {
        const html = parser.parseFromString(text, "text/html");
        if (!this.closest(".section-main-collection")) return;
        if (!this.closest(".section-main-collection").querySelector(".ajax-loadmore")) return;
        if (!html.querySelector(".section-main-collection .ajax-loadmore")) return;
        const animations = this.closest(".section-main-collection").querySelectorAll(".scroll-trigger");
        if (animations.length !== 0) {
          animations.forEach(e => {
            e.classList.remove("scroll-trigger");
          });
        }
        this.closest(".section-main-collection").querySelector(".ajax-loadmore").innerHTML += html.querySelector(".section-main-collection .ajax-loadmore").innerHTML;
        if (this.closest(".section-main-collection").querySelector(".ajax-loadmore .counting_product")) {
          this.closest(".section-main-collection").querySelector(".ajax-loadmore .counting_product").remove();
        }
        if (!html.querySelector(".section-main-collection .ajax-loadmore .counting_product")) return;
        if (!this.querySelector(".counting_product")) return;
        this.querySelector(".counting_product").innerHTML = html.querySelector(".section-main-collection .ajax-loadmore .counting_product").innerHTML;
      })
      .finally(() => {
        initLazyloadItem();
        if (window.SPR) {
          window.SPR.registerCallbacks();
          window.SPR.initRatingHandler();
          window.SPR.initDomEls();
          window.SPR.loadProducts();
          window.SPR.loadBadges();
        }
        _this.updateUrl(Number(this.dataset.url.replace("?page=","")));
        this.classList.remove("loading");
      })
      .catch(e => {
        console.error(e);
      });
  }
  updateUrl(e) {
    const all = this.dataset.allProducts;
    const limit = this.dataset.limit;
    if (all && limit && all > 0 ) {
      const times = ~~(all/limit);
      const remainder = all%limit;
      let pages = times;
      if (remainder > 0) {
        pages = times + 1;
      }
      if (e<pages) {
        this.dataset.url = "?page="+(++e);
      }else{
        const btn = this.querySelector("button");
        if (btn) {
          btn.remove();
        }
      }
    }
  }
}
customElements.define("loadmore-button-collection", Loadmore);

if (!customElements.get('loadmore-infinity')) {
  customElements.define('loadmore-infinity', class LoadInfinity extends Loadmore {
    constructor() {
      super();
    }
    init(){
      this.getHeightBtn();
    }
    getHeightBtn() {
      const _this = this;
      this.btn = this.querySelector("button");
      if (!this.querySelector("button")) return;
      var isVisible = false;
      window.addEventListener('scroll', function() {
        var buttonRect = _this.btn.getBoundingClientRect();
        var viewportHeight = window.innerHeight;
        if (!isVisible && buttonRect.top<=viewportHeight) {
          isVisible = true;
          _this.scanData();
      } else if (isVisible && buttonRect.top>viewportHeight) {
          isVisible = false;
      }
      });
  }
  });
}

if (!customElements.get('moshita-collection-search')) {
  customElements.define('moshita-collection-search', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.input = this.querySelector('input');
      this.clearButton = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.container = document.getElementById('ProductContainer');
      this.sequence = 0;
      this.capture();
      this.input.value = new URL(location.href).searchParams.get('collection_search') || '';
      this.querySelector('form').addEventListener('submit', (event) => {
        event.preventDefault();
        clearTimeout(this.timer);
        this.run();
      });
      this.input.addEventListener('input', () => {
        this.sequence++;
        clearTimeout(this.timer);
        this.clearButton.hidden = !this.input.value;
        this.timer = setTimeout(() => this.run(), 250);
      });
      this.clearButton.addEventListener('click', () => this.clear());
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.input.value) {
          event.preventDefault();
          this.clear();
        }
      });
      if (this.input.value) this.run(false);
    }

    disconnectedCallback() {
      clearTimeout(this.timer);
      this.controller?.abort();
      this.sequence++;
    }

    capture() {
      this.originalHTML = this.container.innerHTML;
      this.originalCounts = [...document.querySelectorAll('#ProductCount, #ProductCountDesktop')].map(el => [el, el.innerHTML]);
      this.baseURL = new URL(location.href);
      this.baseURL.searchParams.delete('collection_search');
      this.baseURL.searchParams.delete('section_id');
      this.baseURL.searchParams.delete('sections');
      this.cache = null;
      this.applied = false;
    }

    clear() {
      clearTimeout(this.timer);
      this.input.value = '';
      this.run();
      this.input.focus();
    }

    prepareFilters(searchParams, preserveSearch) {
      clearTimeout(this.timer);
      this.sequence++;
      this.controller?.abort();
      const params = new URLSearchParams(searchParams);
      if (preserveSearch && this.input.value.trim()) params.set('collection_search', this.input.value.trim());
      this.input.value = params.get('collection_search') || '';
      this.clearButton.hidden = !this.input.value;
      this.filtering = true;
      this.status.textContent = this.input.value ? this.dataset.loading : '';
      this.container.setAttribute('aria-busy', 'true');
      return params.toString();
    }

    filtersRendered() {
      this.filtering = false;
      this.capture();
      this.run(false);
    }

    updateURL(query) {
      const url = new URL(location.href);
      if (query) url.searchParams.set('collection_search', query);
      else url.searchParams.delete('collection_search');
      history.replaceState({ ...history.state, searchParams: url.searchParams.toString() }, '', url);
    }

    async index() {
      if (this.cache) return this.cache;
      const source = new DOMParser().parseFromString(this.originalHTML, 'text/html');
      const info = source.querySelector('[data-collection-pagination]');
      if (!info) throw new Error('Collection pagination unavailable');
      const pageCount = Math.max(1, Number(info.dataset.pages));
      const currentPage = Number(info.dataset.page);
      const expected = Number(info.dataset.count);
      const pageParam = info.dataset.pageParam || 'page';
      const parseCards = (doc) => [...doc.querySelectorAll('#product-grid > .product-wrapper')].map(card => ({
        id: card.querySelector('[data-item-id]')?.dataset.itemId,
        title: card.querySelector('.product-name a')?.textContent.trim() || '',
        html: card.outerHTML
      })).filter(card => card.id);
      const controller = new AbortController();
      this.controller = controller;
      const base = new URL(this.baseURL);
      base.searchParams.set('section_id', this.dataset.section);
      const pages = new Array(pageCount);
      pages[currentPage - 1] = parseCards(source);
      const queue = Array.from({ length: pageCount }, (_, i) => i + 1).filter(page => page !== currentPage);
      const promise = (async () => {
        const timeout = setTimeout(() => controller.abort(), 45000);
        try {
          await Promise.all(Array.from({ length: Math.min(2, queue.length) }, async () => {
            while (queue.length) {
              const page = queue.shift();
              const url = new URL(base);
              url.searchParams.set(pageParam, String(page));
              const response = await fetch(url, { credentials: 'same-origin', signal: controller.signal });
              if (!response.ok) throw new Error('Collection page unavailable');
              const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
              const meta = doc.querySelector('[data-collection-pagination]');
              if (!meta || Number(meta.dataset.page) !== page || Number(meta.dataset.count) !== expected) throw new Error('Collection changed during search');
              pages[page - 1] = parseCards(doc);
            }
          }));
          const cards = [...new Map(pages.flat().map(card => [card.id, card])).values()];
          if (cards.length !== expected) throw new Error('Incomplete collection search');
          return cards;
        } finally {
          clearTimeout(timeout);
        }
      })();
      this.cache = promise;
      promise.catch(() => { if (this.cache === promise) this.cache = null; });
      return promise;
    }

    async run(updateURL = true) {
      const sequence = ++this.sequence;
      const query = this.input.value.trim();
      this.clearButton.hidden = !this.input.value;
      if (updateURL) this.updateURL(query);
      if (this.filtering) return;
      if (!query) {
        this.controller?.abort();
        this.cache = null;
        if (this.applied) {
          this.container.innerHTML = this.originalHTML;
          this.originalCounts.forEach(([el, html]) => el.innerHTML = html);
          this.refreshCards();
          this.applied = false;
        }
        this.status.textContent = '';
        this.container.removeAttribute('aria-busy');
        return;
      }
      this.status.textContent = this.dataset.loading;
      this.container.setAttribute('aria-busy', 'true');
      try {
        const cards = await this.index();
        if (sequence !== this.sequence || !this.isConnected) return;
        const normalize = text => text.normalize('NFKC').toLocaleLowerCase().replace(/\s+/g, ' ').trim();
        const needle = normalize(query);
        const matches = cards.filter(card => normalize(card.title).includes(needle));
        const source = new DOMParser().parseFromString(this.originalHTML, 'text/html');
        const originalGrid = source.getElementById('product-grid');
        const wrapper = document.createElement('div');
        wrapper.className = 'collection';
        if (matches.length) {
          const grid = originalGrid.cloneNode(false);
          grid.classList.remove('collection--empty');
          grid.innerHTML = matches.map(card => card.html).join('');
          wrapper.append(grid);
        } else {
          const empty = document.createElement('p');
          empty.id = 'product-grid';
          empty.dataset.id = this.dataset.section;
          empty.className = 'moshita-collection-search__empty';
          empty.textContent = this.dataset.empty;
          wrapper.append(empty);
        }
        this.container.replaceChildren(wrapper);
        this.applied = true;
        const count = this.dataset.countShort.replace('[count]', String(matches.length));
        this.originalCounts.forEach(([el]) => el.textContent = count);
        this.status.textContent = this.dataset.count.replace('[count]', String(matches.length)).replace('[query]', query);
        this.refreshCards();
      } catch (error) {
        if (sequence === this.sequence && this.isConnected) {
          if (this.applied) {
            this.container.innerHTML = this.originalHTML;
            this.originalCounts.forEach(([el, html]) => el.innerHTML = html);
            this.applied = false;
            this.refreshCards();
          }
          this.status.textContent = this.dataset.error;
        }
      } finally {
        if (sequence === this.sequence) this.container.removeAttribute('aria-busy');
      }
    }

    refreshCards() {
      this.container.querySelectorAll('.scroll-trigger').forEach(el => el.classList.remove('scroll-trigger', 'animate--slide-in'));
      if (typeof initLazyloadItem === 'function') initLazyloadItem();
    }
  });
}
